






































import {Component, Mixins} from "vue-property-decorator";
import NumberGenerator from "@/common/mixins/numberGenerator";
import { ReloadManager } from "@/common/util/reloadManager";
import History from "@/model/history";
import System from "@/model/system";
import {namespace} from "vuex-class";
import historyApi from "@/api/historyApi";
import store from "@/store";

const historyStore = namespace("HistoryStore")
const systemStore = namespace("SystemStore")

@Component({
  name: "orderChecking",
  components: {},
})

export default class OrderChecking extends Mixins(NumberGenerator){
  @systemStore.Getter
  getSystem!: System;
  @historyStore.Getter
  getHistories!: History[];
  public customerNumber = 1;

  async mounted() {
    ReloadManager.load(this.getSystem).connectSocket();
    await this.fetchOrderHistories();
  }

  get historyList(): History[] {
    return this.getHistories;
  }

  get price(): number {
    return this.totalPrice;
  }

  get totalQuantity () {
    // eslint-disable-next-line unicorn/no-array-reduce
    return this.getHistories.reduce((sum, value) => sum + value.quantity, 0)
  }

  get totalPrice () {
    // eslint-disable-next-line unicorn/no-array-reduce
    return this.getHistories.reduce((sum, value) => sum + value.quantity * value.price, 0)
  }

  get devicePrice() {
    return Math.ceil(this.totalPrice / this.customerNumber);
  }

  async fetchOrderHistories() {
    const histories = await historyApi.index()
    store.dispatch('HistoryStore/clear');
    histories.map(item => {
      store.dispatch('HistoryStore/addHistoryToList', item);
    })
  }

  public addCustomerNumber() {
    this.customerNumber++
  }

  public subCustomerNumber() {
    if (this.customerNumber > 0) {
      this.customerNumber--;
    }
  }

  public isDisableByCustomerNumber() {
    return this.customerNumber === 1;
  }

  public priceEachCustomer() {
    return this.customerNumber === 0;
  }
}
